import { render } from "./page.vue?vue&type=template&id=1d41542a&scoped=true"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"

import "./page.vue?vue&type=style&index=0&id=1d41542a&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d41542a"]])

export default __exports__